import { z } from 'zod'
import { LocalUserSchema } from '@/core/infrastructure/schemas/users/core/LocalUserSchema.ts'

/**
 * Représentation d'une requête de pagination
 */
export const PaginationRequestSchema = z.object({
  limit: z.number().nonnegative().nullable().default(null),
  page: z.number().nonnegative().nullable().default(null),
  offset: z.number().nonnegative().nullable().default(null),
  sortBy: z.array(z.string()).nullable().default(null)
})

export type PaginationRequestEntity = z.infer<typeof PaginationRequestSchema>

/**
 * Fonction de création de schéma paginée
 * @param item
 */
export function zPaginationResponseSchemaGenerator<T extends z.ZodTypeAny>(item: T) {
  return z.object({
    content: z.array(item),
    totalElements: z.number().int().nonnegative(),
    totalPages: z.number().int().nonnegative(),
    page: z.number().int().nonnegative(),
    size: z.number().int().nonnegative(),
    hasNext: z.boolean(),
    hasPrevious: z.boolean()
  })
}
/**
 * Représentation d'une réponse de pagination générique
 */
export const PaginationResponseSchema = zPaginationResponseSchemaGenerator(z.unknown())
export type PaginationResponseEntity = z.infer<typeof PaginationResponseSchema>

/**
 * Représentation d'une réponse de pagination utilisateur
 */
export const PaginationResponseSchemaUserSchema = zPaginationResponseSchemaGenerator(LocalUserSchema)
export type PaginationResponseUserEntity = z.infer<typeof PaginationResponseSchemaUserSchema>
